import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PictureInPictureAltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"picture_in_picture_alt"}/>
}
